export default function Footer({ footer }) {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-white py-8 px-6" style={{ borderTop: "1px solid #f0eefe" }}>
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-2">
          <span className="font-extrabold text-violet-600">{footer.logo}</span>
        </div>
        <span className="text-gray-400 text-sm">{footer.institute}</span>
        <span className="text-gray-300 text-sm">© {year} {footer.copy}</span>
      </div>
    </footer>
  );
}